import { Api } from "../config/request";

export default {
  getUploadUrl(payload) {
    return Api.post(`/driver-store-mapping/bulk-update`, payload);
  },
};
